import { Component } from '@angular/core';
import { BaseComponent } from './base-component.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ValidationHandlerService } from '../../services/validation-handler.service';

@Component({
    template: ''
})
export abstract class ModalBaseComponent extends BaseComponent {

    constructor(
        protected override spinnerService: NgxSpinnerService,
        protected override modalService: BsModalService,
        protected override validationHandlerService: ValidationHandlerService,
    ) {
        super(spinnerService, modalService, validationHandlerService);
    }

    public onClose(bsModalRef?: BsModalRef, reason?: string): void {
        this.modalService.setDismissReason(reason);
        this.modalService.hide(bsModalRef?.id);
    }
}
